module.exports = __webpack_public_path__ + "img/51-green.62702eb2.svg";